"use strict";

var _interopRequireDefault = require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/interopRequireDefault.js")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/classCallCheck.js"));

var _createClass2 = _interopRequireDefault(require("/home/sphere-dev/Abroad/abroad-client/node_modules/@babel/runtime/helpers/esm/createClass.js"));

var Survey = /*#__PURE__*/function () {
  function Survey(client) {
    (0, _classCallCheck2["default"])(this, Survey);
    this.client = client;
    this.resourceUrl = '/survey-request';
  }

  (0, _createClass2["default"])(Survey, [{
    key: "sendSurveyRequests",
    value: function sendSurveyRequests(clientId, data) {
      for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
        args[_key - 2] = arguments[_key];
      }

      return this.client.post("".concat(this.resourceUrl, "/custom-360/").concat(clientId), data, args);
    }
  }, {
    key: "sendSurveyQuestion",
    value: function sendSurveyQuestion(clientId, data) {
      for (var _len2 = arguments.length, args = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      return this.client.post("".concat(this.resourceUrl, "/custom-360/").concat(clientId, "/questions"), data, args);
    }
  }, {
    key: "getSurveyQuestions",
    value: function getSurveyQuestions(clientId) {
      for (var _len3 = arguments.length, args = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
        args[_key3 - 1] = arguments[_key3];
      }

      return this.client.get("".concat(this.resourceUrl, "/custom-360/").concat(clientId, "/questions"), args);
    }
  }, {
    key: "getSurveyRequests",
    value: function getSurveyRequests(clientId) {
      for (var _len4 = arguments.length, args = new Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
        args[_key4 - 1] = arguments[_key4];
      }

      return this.client.get("".concat(this.resourceUrl, "/custom-360/").concat(clientId, "/recipients"), args);
    }
  }, {
    key: "getQuesWithAns",
    value: function getQuesWithAns(clientId) {
      for (var _len5 = arguments.length, args = new Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
        args[_key5 - 1] = arguments[_key5];
      }

      return this.client.get("".concat(this.resourceUrl, "/custom-360/").concat(clientId), args);
    }
  }, {
    key: "getAnsStatus",
    value: function getAnsStatus(clientId) {
      for (var _len6 = arguments.length, args = new Array(_len6 > 1 ? _len6 - 1 : 0), _key6 = 1; _key6 < _len6; _key6++) {
        args[_key6 - 1] = arguments[_key6];
      }

      return this.client.get("".concat(this.resourceUrl, "/custom-360/").concat(clientId, "/answer-status"), args);
    }
  }, {
    key: "sendReminder",
    value: function sendReminder(clientId) {
      for (var _len7 = arguments.length, args = new Array(_len7 > 1 ? _len7 - 1 : 0), _key7 = 1; _key7 < _len7; _key7++) {
        args[_key7 - 1] = arguments[_key7];
      }

      return this.client.post("".concat(this.resourceUrl, "/custom-360/").concat(clientId, "/resend-email"), args);
    }
  }]);
  return Survey;
}();

exports["default"] = Survey;